import { Avatar, Button, Radio, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import Icon, { DeleteOutlined } from "@ant-design/icons";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AddIcon } from "../icon/AddIcon";
import {
    SharedComponentDrawer,
    SharedInput,
    StyledCancelButton,
    StyledSubmitButton,
} from "../shared";
import { enumDrawerPlacement } from "@configs";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
import { AddVariantPlusIcon } from "../icon/AddVariantPlusIcon";
import { MinusVariantIcon } from "../icon/MinusVariantIcon";
import { selectApp } from "@redux";

const textString = "390px × 270px Maximum 10MB";

interface IProps {
    showModal: boolean;
    handleClose: () => void;
    selectedService?: any;
}

export const ComponentNewHomeProductDrawer = (props: IProps) => {
    const history = useHistory();
    const { showModal, handleClose, selectedService } = props;
    const { t } = useTranslation();
    const { success, error } = useNotify();
    const [subCategory, setSubCategory] = useState<string[]>(["sub category"]);
    const [CatName, setCatName] = useState<string>("");
    const [categoryImage, setCategoryImage] = useState<string>("");
    const dispatch = useDispatch();
    const { langSetting } = useSelector(selectApp);
    useEffect(() => {
        if (selectedService) {
            setCatName(selectedService.category);
        } else {
            setCatName("");
        }
    }, [selectedService]);

    const handleSave = async () => {
        try {
            await null;
        } catch (error) {
            //
        }
    };
    const radioStyle = {
        display: "block",
        height: "30px",
        lineHeight: "30px",
        marginBottom: 16,
    };

    const onChange = (e: any) => {
        //
    };
    return (
        <SharedComponentDrawer
            title={t("page.details_menu")}
            onClose={handleClose}
            placement={enumDrawerPlacement.BOTTOM}
            visible={showModal}
            width={"auto"}
            height={"90%"}
        >
            <StyledCustomHome>
                <Icon type="close" className="closeBtn" onClick={handleClose} />
                <Swiper
                    slidesPerView={1}
                    spaceBetween={20}
                    grabCursor={true}
                    className="mySwiper"
                    pagination={{
                        type: "fraction",
                    }}
                >
                    <SwiperSlide>
                        <img
                            src={
                                "https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg"
                            }
                        />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img
                            src={
                                "https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg"
                            }
                        />
                    </SwiperSlide>
                </Swiper>
                <div className="drawerBody">
                    <div className="ServiceTitle">
                        <h1 className="topServiceTitle">{selectedService.title}</h1>
                    </div>
                    <div className="description">
                        <p>{selectedService.description}</p>
                    </div>
                    <div className="priceAndArrow">
                        <h2>
                            <span style={{ fontWeight: "normal" }}>
                                {langSetting?.currencyText || "฿"}
                            </span>
                            {selectedService.price}
                        </h2>
                        <div className="priceAndDiscountRow">
                            <span className="oldPrice">฿200.00</span>
                            <div className="discountBadge">
                                <span>%10</span>
                            </div>
                        </div>
                    </div>
                </div>
                {selectedService && selectedService.service_code === "service_1" && (
                    <div className="variantSection">
                        <div className="ServiceTitle">
                            <h1 className="topServiceTitle">Ice Cream</h1>
                        </div>
                        <Radio.Group onChange={onChange}>
                            <Radio style={radioStyle} value={1}>
                                <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                                Vanila
                                <div className="radioPriceDiv">
                                    <span className="oldRadioPrice">฿300.00</span>
                                    <span className="radioPrice">฿100.00</span>
                                </div>
                            </Radio>
                            <Radio style={radioStyle} value={2}>
                                <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                                Vanila
                                <div className="radioPriceDiv">
                                    <span className="oldRadioPrice">฿300.00</span>
                                    <span className="radioPrice">฿100.00</span>
                                </div>
                            </Radio>
                            <Radio style={radioStyle} value={3}>
                                <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                                Vanila
                                <div className="radioPriceDiv">
                                    <span className="oldRadioPrice">฿300.00</span>
                                    <span className="radioPrice">฿100.00</span>
                                </div>
                            </Radio>
                        </Radio.Group>
                    </div>
                )}
                <div className="notationSection">
                    <div className="ServiceTitle">
                        <h1 className="topServiceTitle">Notation</h1>
                    </div>
                    <SharedInput placeholder="Ex. a little sweet" />
                </div>
                <div className="addToCartBtnRow">
                    <div className="leftSide">
                        <div style={{ cursor: "pointer" }}>
                            <MinusVariantIcon />
                        </div>
                        <span>2</span>
                        <div style={{ cursor: "pointer" }}>
                            <AddVariantPlusIcon />
                        </div>
                    </div>
                    <div className="addToCartBtn">
                        <span>Add</span>
                        <span className="price">฿200.00</span>
                    </div>
                </div>
            </StyledCustomHome>
        </SharedComponentDrawer>
    );
};

const StyledCustomHome = styled.div`
    .addToCartBtnRow {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 20px;
        background: #ffffff;
        box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.08);
    }
    .addToCartBtn {
        background: #f22f46;
        border-radius: 74px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 19px 32px;
        gap: 20px;
        span {
            color: #fff;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
        }
        price {
            font-weight: 400;
            font-size: 12px;
            line-height: 19px;
            color: #fff;
        }
    }
    .leftSide {
        width: 50%;
        justify-content: space-evenly;
        display: flex;
        span {
            font-weight: 500;
            font-size: 20px;
            line-height: 27px;
            text-align: center;
            color: #000;
        }
    }
    .priceAndArrow {
        .oldPrice {
            font-weight: 300;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            text-decoration-line: line-through;
            color: #a0a4ab;
        }
    }
    .discountBadge {
        background: #49c549;
        border-radius: 34px;
        padding: 0px 4px;
        font-weight: 300;
        font-size: 8px;
        line-height: 13px;
        text-align: center;
        color: #ffffff;
        place-self: center;
    }
    .priceAndDiscountRow {
        display: flex;
        gap: 5px;
    }
    .ant-input::placeholder {
        font-size: 14px;
    }
`;
